import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import Image from "vino/components/Image";

function OrderItem({ item }) {
	const {
		variant: { name, product },
	} = item;

	return (
		<ListItem className="flex w-full justify-between align-top">
			<div className="w-60 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
				<Image image={product} />
			</div>
			<div className="mx-10 flex flex-1 flex-col w-full align-top">
				<a href="#"> {product.name} </a>
				<Typography className="text-sm text-gray-500">{name}</Typography>
				<Typography className="ml-4"></Typography>
				<Typography className="text-gray-500">Qty {item.quantity}</Typography>
			</div>
		</ListItem>
	);
}

export default OrderItem;
